import type { SanityPageBuilderSection, SanityPageBuilderTextMedia12Section } from "@ouster/shared";
import { TextMediaBlock1_2View } from "~/features/blocks/inventory/text-media1_2";
import { toCraftLinkArray } from "~/features/sanity/link";
import { SanityRichText } from "~/features/sanity/rich-text";
import { hasRenderableSanityMedia, SanityMediaFigure } from "./media-figure";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderTextMedia12Section;
  };
};
export function SanityTextMedia12Section({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const text = sectionContent.text?.length ? <SanityRichText value={sectionContent.text} /> : undefined;
  const hasMedia = hasRenderableSanityMedia(sectionContent.media);
  return <TextMediaBlock1_2View anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} hasSpacer={sectionContent.hasSpacer} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} link={toCraftLinkArray(sectionContent.link)} mediaDesktop={hasMedia ? <SanityMediaFigure fit="cover" media={sectionContent.media} sizes="lg:50vw" /> : undefined} mediaMobile={hasMedia ? <SanityMediaFigure media={sectionContent.media} ratio="3/2" sizes="lg:50vw" /> : undefined} mediaPosition={sectionContent.mediaPosition} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} text={text} theme={sectionSettings?.theme || "white"} />;
}